var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.934,
    height: 45,
    viewBox: "0 0 34.934 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3398",
    "data-name": "Group 3398",
    transform: "translate(452.732 -140.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4758",
    "data-name": "Path 4758",
    d: "M-452.732,473.215a16.98,16.98,0,0,1,2.065-8.174,17.26,17.26,0,0,1,10.594-8.541,1.163,1.163,0,0,1,.681.035,11.639,11.639,0,0,0,8.13.028,1.477,1.477,0,0,1,.892-.021q10.29,3.366,12.31,14.013c.163.858.176,1.745.262,2.66Z",
    transform: "translate(0 -287.515)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4759",
    "data-name": "Path 4759",
    d: "M-339.576,261.609a8.042,8.042,0,0,1-8.052-8.027,8.071,8.071,0,0,1,8.05-8.043,8.067,8.067,0,0,1,8.03,8.018A8.04,8.04,0,0,1-339.576,261.609Z",
    transform: "translate(-95.701 -95.461)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4760",
    "data-name": "Path 4760",
    d: "M-435.074,155.413c.452.008.777.076.937-.419.065-.2.449-.38.711-.422a6.525,6.525,0,0,1,1.339-.014.784.784,0,0,1,.825.858q.009,3.287,0,6.575a.778.778,0,0,1-.8.835c-.461.021-.925.018-1.386,0a.862.862,0,0,1-.763-.531.617.617,0,0,0-.4-.307,3.357,3.357,0,0,1-2.326-5.317,1.038,1.038,0,0,0,.136-.582,14.8,14.8,0,0,1,2.132-7.873,14.842,14.842,0,0,1,11.1-7.374,15.221,15.221,0,0,1,17.051,12.1c.212,1.043.205,2.129.316,3.194a1.356,1.356,0,0,0,.188.61,3.323,3.323,0,0,1-2.4,5.212.535.535,0,0,0-.365.273.78.78,0,0,1-.74.544c-.492.01-.984.019-1.475-.006a.723.723,0,0,1-.745-.78q-.013-3.332,0-6.665a.752.752,0,0,1,.792-.789,10.169,10.169,0,0,1,1.429.014c.223.025.563.18.612.346.143.487.489.473.947.486a12.983,12.983,0,0,0-5.086-9.953A12.939,12.939,0,0,0-427.754,144C-432.307,146.333-434.642,150.267-435.074,155.413Z",
    transform: "translate(-13.785)",
    fill: "#febaba"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadset);
export default __webpack_public_path__ + "static/media/headset.9446441cb6e8d149b71d1b4608af47a4.svg";
export { ForwardRef as ReactComponent };